import AskGeolocation from './AskGeolocation'

export default AskGeolocation
